import React from 'react';
import { Link } from 'react-router-dom';
import PublicPageWrapper from '../../components/PublicPageWrapper';
import { Button } from '../../components/ui/button';
import { ArrowRight, BookOpen } from 'lucide-react';

const divisions = [
  { name: 'Pre-School (ECD)', ages: 'Ages 3-5', grades: ['ECD A', 'ECD B'], color: 'from-pink-400 to-rose-500',
    features: ['Play-based learning', 'Sensory development', 'Creative arts', 'Early literacy & numeracy', 'Social skills', 'Outdoor exploration'],
    desc: 'Our Early Childhood Development programme creates a warm, nurturing environment where young learners discover the joy of learning through play and guided activities.' },
  { name: 'Primary School', ages: 'Ages 6-12', grades: ['Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7'], color: 'from-sky-400 to-blue-500',
    features: ['Cambridge Primary curriculum', 'Mathematics & Sciences', 'English & Shona', 'Social Studies', 'Physical Education', 'ICT & Computing'],
    desc: 'Our Primary division builds strong academic foundations following the Zimbabwe curriculum, fostering curiosity, creativity, and a love for learning.' },
  { name: 'High School', ages: 'Ages 13-19', grades: ['Form 1', 'Form 2', 'Form 3', 'Form 4 (O-Level)', 'Form 5 (A-Level)'], color: 'from-violet-400 to-purple-600',
    features: ['Cambridge IGCSE (O-Level)', 'Cambridge AS & A-Level', 'STEM programmes', 'Subject specialisation', 'University preparation', 'Career guidance'],
    desc: 'Our High School prepares students for O-Level and A-Level examinations, with rigorous academics, leadership development, and comprehensive career guidance for university entrance.' },
];

export default function DivisionsPage() {
  return (
    <PublicPageWrapper title="Our Divisions" subtitle="From ECD through A-Level - pillars of educational excellence following the Zimbabwe curriculum.">
      <div data-testid="divisions-page" className="space-y-8">
        {divisions.map(d => (
          <div key={d.name} className="bg-white rounded-2xl border border-slate-100 p-6 lg:p-8 hover:shadow-md transition-shadow" data-testid={`division-detail-${d.name.toLowerCase().replace(/[\s()]+/g, '-')}`}>
            <div className="lg:flex lg:gap-10">
              <div className="lg:w-2/3">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${d.color} flex items-center justify-center`}><BookOpen className="w-5 h-5 text-white" /></div>
                  <div>
                    <h2 className="text-xl font-bold text-[#1B2A4A]">{d.name}</h2>
                    <p className="text-xs text-slate-400">{d.ages} | {d.grades.join(', ')}</p>
                  </div>
                </div>
                <p className="text-sm text-slate-600 leading-relaxed mb-5">{d.desc}</p>
                <Link to="/admissions"><Button className="rounded-full bg-[#1B2A4A] hover:bg-[#283E6B] text-xs font-bold h-9 px-5">Apply Now <ArrowRight className="w-3.5 h-3.5 ml-1" /></Button></Link>
              </div>
              <div className="lg:w-1/3 mt-5 lg:mt-0">
                <p className="font-bold text-[#1B2A4A] text-xs uppercase tracking-wider mb-3">Key Features</p>
                <ul className="space-y-2">{d.features.map(f => (
                  <li key={f} className="flex items-center gap-2 text-sm text-slate-500"><div className="w-1.5 h-1.5 rounded-full bg-[#E8A830]" />{f}</li>
                ))}</ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </PublicPageWrapper>
  );
}
